import React, { useState } from "react";
import CategoryTable from "./categorytable";
import { Box, Container, Button, Typography, Dialog } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import CategoryAdd from "./categoryadd";

const Index = () => {
  const [openAddModal, setOpenAddModal] = useState(false);

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Başlık ve Ekle Butonu */}
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          mb: 4 
        }}
      >
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 600, color: 'primary.main' }}>
            Kategoriler
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            Ürün kategorilerini ve alt kategorilerini yönetin
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setOpenAddModal(true)}
          sx={{
            px: 3,
            py: 1,
            boxShadow: 2,
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: 4,
            },
            transition: 'all 0.2s'
          }}
        >
          Yeni Kategori Ekle
        </Button>
      </Box>

      {/* Kategori Tablosu */}
      <CategoryTable />

      {/* Kategori Ekleme Modal */}
      <Dialog 
        open={openAddModal}
        onClose={() => setOpenAddModal(false)}
        maxWidth="md"
        fullWidth
      >
        <CategoryAdd onClose={() => setOpenAddModal(false)} />
      </Dialog>
    </Container>
  );
};

export default Index;
